const changeTab = (e, container) => {
    const tab = e.target.closest('.tabbed-content__tab');

    if (tab.classList.contains('is-active')) {
        return;
    } else {
        const currentTab = container.querySelector('.tabbed-content__tab.is-active');
        const currentContent = container.querySelector('.tabbed-content__content--container.is-active');
        currentTab.classList.remove('is-active');
        currentContent.classList.remove('is-active');
        
        const tabIdentifier = tab.dataset.identifier;
        const newContent = container.querySelector(`.tabbed-content__content--container[data-identifier='${tabIdentifier}'`);
        tab.classList.add('is-active');
        newContent.classList.add('is-active');
    }
}

const controlTabbedContent = (container) => {
    const allTabs = Array.from(container.querySelectorAll('.tabbed-content__tab'));

    allTabs.forEach(tab => {
        tab.addEventListener('click', (e) => changeTab(e, container));
    })
}

export { controlTabbedContent };